// extracted by mini-css-extract-plugin
export var header = "header-module--header--4dQNe";
export var languageNav = "header-module--language-nav--THscM";
export var menuIcon = "header-module--menu-icon--EKEC3";